/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const MeetingCard = (props) => {
    const meeting = props?.meeting || {};
    const date = meeting?.date;
    const title = meeting?.title;
    const startTime = meeting?.start_time;
    const endTime = meeting?.end_time;
    const description = meeting?.description;
    const timezone = meeting?.timezone;
    const dateMonth = date ? new Date(date + "T00:00:00").toLocaleDateString("en-US", { month: "short" }) : "";
    const dateDay = date ? new Date(date + "T00:00:00").getDate().toString() : "";

    return (
        <div className="council-meeting-item">
            <div className="council-meeting-date">
                <div className="council-meeting-date-month">{dateMonth}</div>
                <div className="council-meeting-date-day">{dateDay}</div>
            </div>
            <div className="council-meeting-content">
                <div className="council-meeting-title-content">
                    <div className="council-meeting-title">{title}</div>
                    <div className="council-meeting-time">{startTime} {endTime ? `- ${endTime}` : ""}</div>
                </div>
                {description && (
                    <div className="council-meeting-description-content">
                        <div className="council-meeting-description">{description}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

MeetingCard.displayName = "MeetingCard";
export { MeetingCard };

